import { defineMessages } from 'react-intl';

const messages = defineMessages({
  DedicatedAccountManager: {
    description: 'dedicated account manager plan added benefit',
    defaultMessage: 'Dedicated Account Manager',
    id: 'wHZYsX',
  },
  ApiIntegration: {
    defaultMessage: 'API Integration',
    id: 'ezLTd2',
    description: 'API integration premium feature label',
  },
  PrioritySupport: {
    description: 'priority support plan added benefit',
    defaultMessage: 'Priority Support',
    id: 'FmKtQl',
  },
  Cubiscan: {
    description: 'Cubiscan plan added benefit',
    defaultMessage: 'Cubiscan',
    id: 'yXAPNl',
  },
  ODBC: {
    description: 'ODBC plan added benefit',
    defaultMessage: 'ODBC',
    id: 'bpxgAF',
  },
  ProductBundles: {
    description: 'Product Bundles plan added benefit',
    defaultMessage: 'Product Bundles',
    id: 'HtVlRq',
  },
  AutoSplit: {
    description: 'AutoSplit plan added benefit',
    defaultMessage: 'Auto-Split',
    id: '8ZT57z',
  },
  OrderRouting: {
    description: 'OrderRouting plan added benefit',
    defaultMessage: 'Order Routing',
    id: 'Qgtb+V',
  },
  ShippingStrategies: {
    description: 'Rate shopper plan added benefit',
    defaultMessage: 'Rate Shopper',
    id: 'HfpicD',
  },
  moreIncluded: {
    description: 'more benefits included button',
    defaultMessage: '{count} included',
    id: 'lc+Hpi',
  },
});

export default messages;
